module.exports = __webpack_public_path__ + "static/DasaSans-Regular-3a595612987e8263acbcd31d9634596b.woff2";